import React from 'react';
import { Link } from 'react-router-dom';
import site from '../../content/siteContent';

export default function LocationsIndex() {
  // Get unique locations from services
  const locations = [...new Set(site.services[0].locations)];

  return (
    <div className="min-h-screen bg-sand/5">
      {/* Hero Section */}
      <div className="bg-wood text-sand py-16">
        <div className="container">
          <h1 className="text-4xl font-bold mb-4">Our Service Locations</h1>
          <p className="text-sand/90 max-w-2xl text-content">
            Find premium interior design services in your area. We serve Valliyur and surrounding
            regions with our end-to-end interior solutions.
          </p>
        </div>
      </div>

      <div className="container py-12">
        {/* Breadcrumb */}
        <div className="mb-8">
          <nav className="text-sm text-neutralText">
            <Link to="/" className="hover:text-wood">
              Home
            </Link>
            <span className="mx-2">/</span>
            <span className="text-wood">Locations</span>
          </nav>
        </div>

        {/* Locations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {locations.map((location) => {
            const locationProjects = site.projects.filter(
              (project) => project.location === location
            );
            return (
              <Link
                key={location}
                to={`/locations/${location.toLowerCase()}`}
                className="card overflow-hidden group"
              >
                {locationProjects[0] && (
                  <div className="relative">
                    <img
                      src={locationProjects[0].img}
                      alt={`Interior Design Services in ${location}`}
                      className="w-full h-48 object-cover transition-transform group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                      <div className="text-center">
                        <h2 className="text-2xl font-bold text-white mb-2">{location}</h2>
                        <p className="text-white/90 text-sm">View our projects in {location}</p>
                      </div>
                    </div>
                  </div>
                )}
              </Link>
            );
          })}
        </div>

        {/* SEO Content */}
        <section className="mt-12 prose max-w-none">
          <h2 className="text-2xl font-semibold mb-6">
            Premium Interior Design Services Across Tamil Nadu
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <p className="text-neutralText">
                Sri GDM Interior Industries provides exceptional interior design and execution
                services in Valliyur, Tirunelveli, and surrounding areas including Nagercoil,
                Panagudi, Kalakad, Eruvadi, Thisaynavilai, Vadakkankulam, and Kudankulam. Our team
                of experienced designers and craftsmen bring together traditional values and modern
                aesthetics to create spaces that reflect your personality and lifestyle.
              </p>
            </div>
            <div>
              <p className="text-neutralText">
                From modular kitchens and office interiors to residential projects, we handle work
                of all scales with the same attention to detail and commitment to quality. Every
                project is backed by our state-of-the-art manufacturing facility in Valliyur and
                expert installation team serving the entire region.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
